import { defineComponent, onMounted, onUnmounted } from "vue";
import { useDataStore } from '@/store'

import ExcelWorker from '@/utils/excel.worker.js'

export default defineComponent({
  setup() {
    const dataStore = useDataStore()
    let worker
    onMounted(() => {
      worker = new ExcelWorker()
      worker.addEventListener("message", (e) => {
        let res = e.data
        if (res.type === "finish") {
          dataStore.updateData(res.data.reportsData)
          dataStore.updateCategoryData(res.data.categoryData)
          worker.terminate()
          worker = null
        }
      })
    })
    onUnmounted(() => {
      if (worker) {
        worker.terminate()
        worker = null
      }
    })
    return () => {
      return (
        <>
          <RouterView />
        </>
      )
    }
  }
})